import { Component, OnInit, NgZone, ViewChild, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { SiteListAccessService } from '../site-list-access.service';
import { takeUntil, throttle } from 'rxjs/operators';
import { AgmMap, LatLngLiteral } from '@agm/core';
import { ClusterStyle } from '@agm/js-marker-clusterer/services/google-clusterer-types';
import { ControlPosition, MapTypeStyler } from '@agm/core/services/google-maps-types';
import { PlantingSiteDto } from '../../../../models/trofaco/plantingSiteDto';
import { BaseComponent } from 'src/app/modules/core/components/bases/base-component';

declare var google: any;

@Component({
  selector: 'app-list-map',
  templateUrl: './list-map.component.html',
  styleUrls: ['./list-map.component.css']
})
export class ListMapComponent extends BaseComponent implements OnInit, AfterViewInit {
    @ViewChild(AgmMap, {static: true}) map: AgmMap;

    isReady = false;
    zoomDoneMs = 1000;
    readonly mapTypeId = 'hybrid';
    labelBar = 'assets/img/map-icons/bar-label.png'
    nowDate = new Date().getTime();

    constructor(private siteAccess: SiteListAccessService, private ngZone: NgZone, private router: Router){
        super();
    }

    clusterStyles: ClusterStyle[] = [
        {
            textColor: "#FFFFFF",
            url: "/assets/img/map-icons/cluster/cluster.png",
            height: 54,
            width: 54,
            textSize: 14
        }
    ];

    sites: PlantingSiteDto[];
    activeSite: PlantingSiteDto;
    ngOnInit() {
        // init value here is to prevent sometimes zoom ctrl missing on iPhone
        this.sites =  [{}];
    }

    onMapReady(){
        this.siteAccess.filteredSites$
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(sites => this.sites = sites);

        this.map.centerChange
            .pipe(
                throttle(() => this.siteAccess.filteredSites$),
                takeUntil(this.onDestroy$)
            )
            .subscribe((center) => {
                this.selectAtCenter(<LatLngLiteral>center);

                // set zoom level to anything to prevent gg map does not load on mobile
                this.map.zoom = 5;

                this.isReady = false;
                this.zooming();
            });
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.map.triggerResize();
        }, 200);
    }

    zooming(zoomTimeout: number = this.zoomDoneMs){
        setTimeout(() => {
            this.isReady = true;
        }, zoomTimeout);
    }

    selectAtCenter(center: LatLngLiteral) {
        if (!this.sites) return;
        let centerObj = new google.maps.LatLng(center);
        let minDistance = Infinity;
        let closestSite: PlantingSiteDto;
        for (let site of this.sites) {
            let location = new google.maps.LatLng({lat: site.lat, lng: site.lon});
            let dist = google.maps.geometry.spherical.computeDistanceBetween(centerObj, location);
            if (dist < minDistance) {
                minDistance = dist;
                closestSite = site;
            }
        }
        this.activeSite = closestSite;
        this.zooming();
    }

    showDetail(site: PlantingSiteDto) {
        this.isReady = false;
        this.activeSite = site;
        this.zooming(0);
    }

    windowClosed(site: PlantingSiteDto) {
        this.ngZone.run(() => {
            if (site === this.activeSite) {
                this.activeSite = null
            }
        });
    }

    navigateToPlanting(siteId: string, areaId: string): void {
        this.router.navigateByUrl('/plantingSite/' + siteId + '/area/' + areaId);
    }

}
